export enum DataFieldType {
  ADDRESS = 'ADDRESS',
  AGE = 'AGE',
  ARRAY_MULTIPLE = 'ARRAY_MULTIPLE',
  ARRAY_SINGLE = 'ARRAY_SINGLE',
  ATTACHMENT = 'ATTACHMENT',
  BOOLEAN = 'BOOLEAN',
  CLAUSE = 'CLAUSE',
  DATE = 'DATE',
  MONETARY = 'MONETARY',
  NUMBER = 'NUMBER',
  REFERENCE = 'REFERENCE',
  STRING = 'STRING',
  TEXT_AREA = 'TEXT_AREA',
}
